import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { MdArrowBack, MdArticle } from "react-icons/md";
import { useLanguage } from "context/LanguageContext";
import ReportView from "./ReportView";

const SessionReportPage: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const navigate = useNavigate();
  const { t } = useLanguage();

  if (!sessionId) {
    return (
      <div className="flex items-center justify-center py-24 text-ink-subtle">
        <span className="text-sm">{t("sessionReportPage.notFound")}</span>
      </div>
    );
  }

  return (
    <div className="mx-auto mt-3 max-w-4xl px-2 pb-10">
      {/* ── Page header ── */}
      <div className="mb-6 flex items-center gap-3">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1.5 rounded-xl px-3 py-2 text-sm font-medium text-ink-muted transition-colors hover:bg-surface-hover hover:text-gray-700 dark:hover:text-white"
        >
          <MdArrowBack className="h-5 w-5" />
          {t("action.back")}
        </button>

        <div className="h-6 w-px bg-gray-200 dark:bg-surface-muted" />

        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-500/10">
            <MdArticle className="h-5 w-5 text-brand-500" />
          </div>
          <div>
            <h1 className="text-lg font-bold leading-tight text-ink">
              {t("sessionReportPage.title")}
            </h1>
            <p className="text-xs text-ink-subtle">
              {t("sessionReportPage.subtitle")}
            </p>
          </div>
        </div>
      </div>

      {/* ── Report list ── */}
      <ReportView sessionId={sessionId} />
    </div>
  );
};

export default SessionReportPage;
